import * as Yup from "yup";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import { quotationBoqItemSchema } from "features/Quotations/QuotationForm/schema";

const schema = Yup.object({
  supplierId: Yup.number()
    .integer()
    .positive("Supplier must be a valid selection")
    .nullable()
    .optional(),
  orderDate: Yup.string().required("Order date is required"),
  expectedDate: Yup.string()
    .nullable()
    .optional()
    .test(
      "expected-gte-order",
      "Expected date cannot be earlier than the order date.",
      function (value) {
        const { orderDate } = this.parent as { orderDate?: string };
        if (!value || !orderDate) return true;
        return value >= orderDate;
      },
    ),
  notes: Yup.string().max(8000).nullable().optional(),
  items: Yup.array()
    .of(quotationBoqItemSchema)
    .min(1, "At least one line is required")
    .test(
      "po-has-line",
      "At least one line with a description is required",
      (rows) =>
        Array.isArray(rows) &&
        rows.some(
          (r: { type?: string; description?: unknown }) =>
            r?.type === QuotationItemType.MATERIAL &&
            typeof r?.description === "string" &&
            r.description.trim() !== "",
        ),
    ),
});

export default schema;
